import React from 'react';
import { Icon } from '@modulor/react';
import { NAMESPACES } from '../../../constants/namespaces';
import { getFavoritesRoute, getRootRoute } from '../../../utils/routes';
import Local from '../../../components/Local/Local';
import Modal from '../../../components/Modal/Modal';
import MainNavigationItem from '../../../components/Navigation/MainNavigation/MainNavigationItem';
import IconButton from '../../../components/Button/IconButton/IconButton';
import styles from './AppReviewModalMenu.module.css';

const ModalMenu = ({ isOpen, setIsOpen }) => (
  <Modal
    isOpen={isOpen}
    className={styles.modal}
    overlayClassName={styles.overlay}
  >
    <div className={styles.modalHeader}>
      <IconButton onClick={() => setIsOpen(false)} className={styles.close}>
        <Icon name="close" />
      </IconButton>
    </div>

    <MainNavigationItem
      className={styles.navItem}
      to={getRootRoute()}
      icon={<Icon name="home_outlined" />}
    >
      <Local namespace={NAMESPACES.PAGES}>Main</Local>
    </MainNavigationItem>

    <MainNavigationItem
      className={styles.navItem}
      to={getFavoritesRoute()}
      icon={<Icon name="star_filled" />}
    >
      <Local namespace={NAMESPACES.PAGES}>Favorites</Local>
    </MainNavigationItem>
  </Modal>
);

export default ModalMenu;
